var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import api from '@utils/axios';
/**
 * `useDirectUpload`'s `DirectUploadTransport` implementation for building attachments.
 *
 * Deliberately uses the raw `@utils/axios` client, NOT `@utils/api-client` (`buildingAttachmentsApi.ts`'s
 * own client) -- `api-client`'s `axios-case-converter` middleware would camelCase this endpoint's
 * response (`signed_id` -> `signedId`) and the hook expects the Frozen contract's wire shapes
 * verbatim, snake_case included (contracts/direct-uploads-office.md, "Explicitly not a divergence
 * -- field casing"; the controller itself renders plain hashes rather than an
 * `Api::Internal::BaseSerializer` for the same reason). Mirrors
 * `CustomerFileDrop/services/CustomerFileDropService.ts`'s own use of the raw client for the same
 * reason.
 */
export function createDirectUploadTransport(buildingId) {
    const base = `/api/internal/buildings/${buildingId}/attachment_uploads`;
    return {
        presign: (request, signal) => __awaiter(this, void 0, void 0, function* () {
            const response = yield api.post(base, request, { signal });
            return response.data;
        }),
        finalize: (request, signal) => __awaiter(this, void 0, void 0, function* () {
            const response = yield api.post(`${base}/finalize`, request, { signal });
            return response.data;
        })
    };
}
